"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var HorseRiding = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(HorseRiding, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(HorseRiding);

  function HorseRiding() {
    (0, _classCallCheck2["default"])(this, HorseRiding);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(HorseRiding, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M10.7830089,4.8060286 C10.0162506,4.8060286 9.39357852,4.17864277 9.39357852,3.40608003 C9.39357852,2.62738583 10.0162506,2 10.7830089,2 C11.5542822,2 12.1785247,2.62718804 12.1785247,3.40608003 C12.1785247,4.17864277 11.5544785,4.8060286 10.7830089,4.8060286 Z M21.1303199,8.84685219 L19.6549089,8.56243201 L18.7960846,10.2822049 C18.9356558,10.3146423 19.079742,10.3300699 19.226969,10.3300699 C20.1427211,10.3302676 20.9094794,9.70288178 21.1303199,8.84685219 Z M3,11.7503906 C3,10.6099409 3.91555573,9.68290512 5.04743703,9.68290512 L9.36452572,9.68290512 L9.36452572,6.55843668 C9.36452572,5.781127 9.98719785,5.15374117 10.7600415,5.15374117 C11.5315111,5.15374117 12.1541832,5.781127 12.1541832,6.55843668 L12.1541832,7.0420301 L14.2108465,7.57210388 C14.5696878,7.65557072 14.7997545,8.0171285 14.7184852,8.37868629 C14.6372159,8.74637552 14.2768042,8.97363476 13.9132516,8.89175023 L12.1541832,8.47599834 L12.1541832,9.68290512 L14.2245877,9.68290512 L19.8896869,3.77713167 L19.7210629,5.31315888 L22.5107204,7.18127336 C22.9708539,7.44710141 23.1379075,8.04659902 22.8756471,8.51021579 C22.6685477,8.88106964 22.2561158,9.06026622 21.8680254,8.98767776 L21.6426699,8.94594434 C21.3743241,10.0399138 20.3928107,10.8464962 19.2271653,10.8464962 C18.9970986,10.8464962 18.7733135,10.8124765 18.5615029,10.7553156 L16.4483045,15.1050851 L16.4483045,21.0727665 C16.4483045,21.5842481 16.0311613,22 15.5235225,22 C15.0158838,22 14.6032555,21.5842481 14.6032555,21.0727665 L14.6032555,14.9690065 L9.9396926,14.9690065 L9.10540618,16.4075239 L10.8507334,20.5996558 C11.105338,21.0492296 10.9457439,21.613323 10.5056332,21.8651081 C10.0594372,22.1200578 9.49958197,21.9608378 9.24497739,21.5173955 L7.20833701,16.6780989 L7.20833701,15.1375225 L6.29729624,16.5823691 L6.29729624,21.0727665 C6.29729624,21.5842481 5.88466799,22 5.37702924,22 C4.86939049,22 4.45224728,21.5842481 4.45224728,21.0727665 L4.45224728,15.886944 L5.21449061,14.6847841 L5.21449061,10.6176546 L4.45695854,11.7857948 L4.45695854,15.1713444 L3,15.1713444 L3,11.7503906 Z"
      }));
    }
  }]);
  return HorseRiding;
}(_react["default"].PureComponent);

var _default = HorseRiding;
exports["default"] = _default;